import { rollRange } from './rules';

// A small starter spellbook drawn from the MM3 Sorcerer and Cleric lists.
// Offensive spells always strike; cost may scale with the caster's level.
export const SPELLS = {
    magicArrow: {
        id: 'magicArrow',
        icon: 'magic_arrow',
        name: 'Magic Arrow',
        description: '8 damage to one foe',
        target: 'enemy',
        cost: () => 2,
        damage: () => 8,
    },
    energyBlast: {
        id: 'energyBlast',
        icon: 'energy_blast',
        name: 'Energy Blast',
        description: '2-6 damage per caster level to one foe',
        target: 'enemy',
        cost: (caster) => caster.level,
        // 2-6 points per caster level
        damage: (caster, rng) => {
            let total = 0;
            for (let i = 0; i < caster.level; i++) {
                total += rollRange(2, 6, rng);
            }
            return total;
        },
    },
    flyingFist: {
        id: 'flyingFist',
        icon: 'flying_fist',
        name: 'Flying Fist',
        description: '6 damage to one foe',
        target: 'enemy',
        cost: () => 2,
        damage: () => 6,
    },
    lightningBolt: {
        id: 'lightningBolt',
        name: 'Lightning Bolt',
        icon: 'energy_blast',
        description: 'Forks through every foe for 2-16 damage',
        target: 'allEnemies',
        cost: () => 4,
        damage: (caster, rng) => rollRange(2, 16, rng),
        // Taught by trainers rather than known from the start
        learnedBy: ['Sorcerer'],
        price: 400,
    },
    prayerOfHealing: {
        id: 'prayerOfHealing',
        name: 'Prayer of Healing',
        icon: 'first_aid',
        description: 'Heals the whole party by 8',
        target: 'party',
        cost: () => 4,
        heal: () => 8,
        learnedBy: ['Cleric', 'Ranger'],
        price: 350,
    },
    firstAid: {
        id: 'firstAid',
        icon: 'first_aid',
        name: 'First Aid',
        description: 'Heals 6 HP; wakes an unconscious ally',
        target: 'ally',
        cost: () => 1,
        heal: () => 6,
    },
};

// Spells that mend rather than harm can be cast at any time. The rest need a
// foe to aim at, so they are only offered once a fight has started.
export function castableOutsideCombat(spell) {
    return !!spell && !!spell.heal;
}

export function spellCost(spellId, caster) {
    return SPELLS[spellId].cost(caster);
}

// Spells a character could still be taught, with what they cost to learn
export function teachableTo(character) {
    return Object.values(SPELLS).filter((spell) =>
        spell.learnedBy && spell.learnedBy.includes(character.className) &&
        !character.spells.includes(spell.id));
}
